"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _input = require("@alicd/next/lib/input");

var _input2 = _interopRequireDefault(_input);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _moment = require("@alicd/next/lib/moment");

var _moment2 = _interopRequireDefault(_moment);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _grid = require("@alicd/next/lib/grid");

var _grid2 = _interopRequireDefault(_grid);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cruiCalendarEx = require("@alicd/crui-calendar-ex");

var _utils = require("@alicd/next/lib/_components/@alicd/next-date-picker/lib/view/utils");

var _boundUtils = require("./boundUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;


var alwaysTrue = function alwaysTrue() {
    return true;
};

var RangePickerSidePanel = function (_React$Component) {
    (0, _inherits3.default)(RangePickerSidePanel, _React$Component);

    function RangePickerSidePanel(props) {
        (0, _classCallCheck3.default)(this, RangePickerSidePanel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RangePickerSidePanel.__proto__ || (0, _getPrototypeOf2.default)(RangePickerSidePanel)).call(this, props));

        _this.state = {
            isTime: false,
            inputChange: null,
            inputValue: ""
        };

        _this.switchToDate = _this.switchTo.bind(_this, false);
        _this.switchToTime = _this.switchTo.bind(_this, true);

        _this.handleChangeDate = _this.handleChangeDate.bind(_this);
        _this.handleChangeTime = _this.handleChange.bind(_this);

        _this.handleDateInputChange = _this.handleInputChange.bind(_this, "date");
        _this.handleTimeInputChange = _this.handleInputChange.bind(_this, "time");
        _this.handleDateInputBlur = _this.handleInputBlur.bind(_this, "date");
        _this.handleTimeInputBlur = _this.handleInputBlur.bind(_this, "time");
        _this.handleDateInputKeyPress = _this.handleInputKeyPress.bind(_this, "date");
        _this.handleTimeInputKeyPress = _this.handleInputKeyPress.bind(_this, "time");
        return _this;
    }

    (0, _createClass3.default)(RangePickerSidePanel, [{
        key: "switchTo",
        value: function switchTo(isTime) {
            this.setState({ isTime: isTime });
        }
    }, {
        key: "getResetDefaultTime",
        value: function getResetDefaultTime() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            if (props.showTime.defaultValue) {
                var vs = Array.isArray(props.showTime.defaultValue) ? props.showTime.defaultValue[props.idx] : props.showTime.defaultValue;
                var v = toMoment(vs, props.format.timeFormat);
                return [v.hour(), v.minute(), v.second()];
            } else {
                return [0, 0, 0];
            }
        }
    }, {
        key: "handleChangeDate",
        value: function handleChangeDate(_ref) {
            var base = _ref.base,
                mode = _ref.mode,
                value = _ref.value;

            if (value) {
                if (!this.props.value || this.props.resetTime) {
                    var _getResetDefaultTime = this.getResetDefaultTime(),
                        _getResetDefaultTime2 = (0, _slicedToArray3.default)(_getResetDefaultTime, 3),
                        h = _getResetDefaultTime2[0],
                        m = _getResetDefaultTime2[1],
                        s = _getResetDefaultTime2[2];

                    value = value.hour(h).minute(m).second(s);
                }
                value = (0, _boundUtils.correctTimeWithBounds)(this.props, value);
                this.handleChange(value);
            }
        }
    }, {
        key: "handleChange",
        value: function handleChange(value) {
            typeof this.props.onChange == "function" && this.props.onChange(value);
        }
    }, {
        key: "handleInputChange",
        value: function handleInputChange(which, value) {
            this.setState({ inputChange: which, inputValue: value });
        }
    }, {
        key: "handleInputKeyPress",
        value: function handleInputKeyPress(which, e) {
            // what's the correct way to detect Enter?
            if (e.charCode == 13) {
                this.handleDateInputBlur(which);
            }
        }
    }, {
        key: "handleInputBlur",
        value: function handleInputBlur(which) {
            if (this.state.inputChange && this.state.inputValue) {
                var _props = this.props,
                    _format = _props.format,
                    disabledDate = _props.disabledDate;

                if (!(0, _utils.isFunction)(_format.dateFormat)) {
                    var parsed = (0, _moment2.default)(this.state.inputValue, which == "time" ? _format.timeFormat : _format.dateFormat);
                    if (parsed.isValid()) {
                        if (which == "time") {
                            parsed = this.props.value.clone().hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());
                        }
                        if (!disabledDate((0, _utils.getCalendarDate)(parsed)) && (0, _boundUtils.inBounds)(this.props, parsed)) {
                            this.handleChange(parsed);
                        }
                    }
                }
            }
            this.setState({ inputChange: null, inputValue: "" });
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                showTime = _props2.showTime,
                value = _props2.value,
                onChange = _props2.onChange,
                format = _props2.format,
                locale = _props2.locale,
                disabled = _props2.disabled,
                readOnly = _props2.readOnly,
                size = _props2.size,
                resetTime = _props2.resetTime,
                disabledDate = _props2.disabledDate,
                disabledHours = _props2.disabledHours,
                disabledMinutes = _props2.disabledMinutes,
                disabledSeconds = _props2.disabledSeconds,
                altLowerBound = _props2.altLowerBound,
                altUpperBound = _props2.altUpperBound,
                rest = (0, _objectWithoutProperties3.default)(_props2, ["showTime", "value", "onChange", "format", "locale", "disabled", "readOnly", "size", "resetTime", "disabledDate", "disabledHours", "disabledMinutes", "disabledSeconds", "altLowerBound", "altUpperBound"]);

            var parts = (0, _utils.parseDateParts)(value, format.dateFormat, format.timeFormat, format.dataTimeFormat);
            return _react2.default.createElement(
                "div",
                { className: "cn-range-picker-side-body" },
                _react2.default.createElement(
                    Row,
                    { className: "cn-range-picker-input-cont", type: "no-padding" },
                    _react2.default.createElement(
                        Col,
                        null,
                        _react2.default.createElement(_input2.default, {
                            className: "cn-range-picker-input",
                            onClick: this.switchToDate,
                            value: this.state.inputChange == "date" ? this.state.inputValue : parts.dateString,
                            onChange: this.handleDateInputChange,
                            onBlur: this.handleDateInputBlur,
                            onKeyPress: this.handleDateInputKeyPress,
                            placeholder: (0, _utils.isFunction)(format.dateFormat) ? locale.selectDate : format.dateFormat,
                            disabled: disabled,
                            readOnly: readOnly,
                            size: size
                        })
                    ),
                    !showTime ? null : _react2.default.createElement(
                        Col,
                        null,
                        _react2.default.createElement(_input2.default, {
                            className: "cn-range-picker-input",
                            onClick: this.switchToTime,
                            value: this.state.inputChange == "time" ? this.state.inputValue : parts.timeString,
                            onChange: this.handleTimeInputChange,
                            onBlur: this.handleTimeInputBlur,
                            onKeyPress: this.handleTimeInputKeyPress,
                            placeholder: (0, _utils.isFunction)(format.timeFormat) ? locale.selectTime : format.timeFormat,
                            disabled: disabled || !this.props.value,
                            readOnly: readOnly,
                            size: size
                        })
                    )
                ),
                this.state.isTime ? _react2.default.createElement(_cruiCalendarEx.TimePickerPanel, {
                    value: value,
                    onChange: this.handleChangeTime,
                    disabled: disabled,
                    disabledHours: disabledHours,
                    disabledMinutes: disabledMinutes,
                    disabledSeconds: disabledSeconds,
                    altLowerBound: altLowerBound,
                    altUpperBound: altUpperBound
                }) : _react2.default.createElement(_cruiCalendarEx.DatePickerPanel, {
                    value: value,
                    onChange: this.handleChangeDate,
                    disabledDate: disabled ? alwaysTrue : disabledDate,
                    altLowerBound: altLowerBound,
                    altUpperBound: altUpperBound
                })
            );
        }
    }]);
    return RangePickerSidePanel;
}(_react2.default.Component);

RangePickerSidePanel.propTypes = {
    className: _propTypes2.default.string,
    size: _propTypes2.default.oneOf(["small", "medium", "large"]),
    value: _propTypes2.default.any,
    disabledDate: _propTypes2.default.func,
    disabledHours: _propTypes2.default.func,
    disabledMinutes: _propTypes2.default.func,
    disabledSeconds: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    showTime: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    disabled: _propTypes2.default.bool,
    readOnly: _propTypes2.default.bool,
    resetTime: _propTypes2.default.bool,
    idx: _propTypes2.default.number,
    altLowerBound: _propTypes2.default.object,
    altUpperBound: _propTypes2.default.object
};
exports.default = RangePickerSidePanel;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-date-range-picker@0.0.3@@alicd/crui-date-range-picker/lib/RangePickerSidePanel.js
// module id = 622
// module chunks = 0